/* */
import { Stack, Text, Grid } from "@mantine/core";
import RegionToText from "./RegionToText";

export default function RegionInfo(props) {
  // If no active capacity in any region, nothing
  if (!props.regions || !props.regions.length) {
    return null;
  }
  let isConnected = false;
  for (const region of props.regions) {
    if (region.capacity || region.sessions) {
      isConnected = true;
      break;
    }
  }
  if (!isConnected) {
    return null;
  }
  let border = "1px solid rgba(107, 110, 112, 0.25)";
  if (props.noLine) {
    border = "";
  }
  // Else display the capacity and session count per region
  return (
    <Stack
      spacing={0}
      sx={{
        borderBottom: { border },
        borderRadius: "7px",
      }}
    >
      <Grid columns={24}>
        <Grid.Col span={4}>
          <Text>Region</Text>
        </Grid.Col>
        <Grid.Col span={4}>
          <Text>Capacity</Text>
        </Grid.Col>
        <Grid.Col span={4}>
          <Text>Sessions</Text>
        </Grid.Col>
        <Grid.Col span={4}></Grid.Col>
        <Grid.Col span={4}></Grid.Col>
        <Grid.Col span={4}></Grid.Col>
      </Grid>
      {props.regions.map(function (item, idx2) {
        if (!item.capacity && !item.sessions) {
          return;
        }
        return (
          <Grid columns={24} key={"connStat-" + props.address + "-" + idx2}>
            <Grid.Col span={4}>
              <RegionToText
                orchestratorName={item.orchestratorName}
                orchestratorRegion={item.orchestratorRegion}
              />
            </Grid.Col>
            <Grid.Col span={4}>
              <Text>{item.capacity}</Text>
            </Grid.Col>
            <Grid.Col span={4}>
              <Text>{item.sessions}</Text>
            </Grid.Col>
            <Grid.Col span={4}></Grid.Col>
            <Grid.Col span={4}></Grid.Col>
            <Grid.Col span={4}></Grid.Col>
          </Grid>
        );
      })}
    </Stack>
  );
}
